import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

/**
 * Reads `data.permission` from the activated (child) route and blocks navigation
 * when the current user lacks that permission. Routes without a `permission`
 * are always allowed. Declared as `canActivateChild` on the app shell so it
 * applies to every descendant route, including lazy-loaded ones.
 */
export const permissionGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
	const platformId = inject(PLATFORM_ID);
	const authStore = inject(AuthStore);
	const router = inject(Router);

	// On the server we can't read the user session reliably; defer to client.
	if (!isPlatformBrowser(platformId)) return true;

	const permission = route.data?.['permission'] as string | undefined;
	if (!permission) return true;

	if (authStore.can(permission)) return true;

	return router.createUrlTree(['/forbidden']);
};
